import React, { useState } from 'react'
import { 
    Card,
    Col,
    Container,
    Row,
    CardBody,
    CardTitle,
    Label,
    Button,
    Form,
    Input,
    CardSubtitle,
    Table,
    InputGroup,
    UncontrolledAlert,
   } from "reactstrap";

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";
import { useNavigate  } from 'react-router';
import {addrole} from '../../service/myapi';
import DatatableTables from './DatatableTables';

const defaultValue ={
  role:''
}

const AddRole = () => {
  const[role,setrole] = useState(defaultValue);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [message, setMessage] = useState('');
  const navigate = useNavigate();

  const onchangevalue = (e)=>{
    setrole({...role,[e.target.name]:e.target.value});
  }
  const onclickbutton = async (e) => {
    e.preventDefault();
    try {
      const response = await addrole(role);
      setIsSubmitted(true);
      setMessage(response.data.message); 
      document.getElementById('rolefield').value = '';
    } catch (error) {
      console.log('Error while adding role: ', error);
      setIsSubmitted(true);
      setMessage(error.response.data.message); 
    }
    setTimeout(() => {
      navigate('/AddRole');
      setIsSubmitted(false);
    }, 2000);
  };
  return (
    <React.Fragment>
      {/* <div className="page-content"> */}
        {/* <Container fluid> */}
          {/* Render Breadcrumbs */}
          {/* <Breadcrumbs title="Setting" breadcrumbItem="Users" /> */}
          <DatatableTables />

        {/* </Container> */}
      {/* </div> */}
    </React.Fragment>
  )
}

export default AddRole
